(function () {
  'use strict';

  function initCatalogSection(section) {
    if (!section || section.dataset.catalogInitialized === 'true') return;

    var track = section.querySelector('[data-catalog-track]');
    if (!track) return;

    var wheelSpeed = parseFloat(section.dataset.wheelSpeed || '1');
    if (!isFinite(wheelSpeed) || wheelSpeed <= 0) wheelSpeed = 1;

    var keyboardNav = section.dataset.keyboardNav === 'true';
    var clickNavigation = section.dataset.clickNavigation === 'true';
    var originalSlides = Array.prototype.filter.call(track.children, function (child) {
      return child.nodeType === 1;
    });

    var dragging = false;
    var dragMoved = false;
    var dragStartX = 0;
    var dragStartScrollLeft = 0;
    var activePointerId = null;
    var resizeFrame = null;
    var settleTimer = null;
    var navbarStateFrame = null;
    var scrollCorrectionLocked = false;
    var pendingProgrammaticWrap = false;
    var loopThreshold = 2;
    var loopStart = 0;
    var loopSpan = 0;
    var loopingEnabled = false;
    var navbarOptionClasses = [
      'catalog-strip-hide-navbar-cart-desktop',
      'catalog-strip-hide-navbar-cart-mobile',
      'catalog-strip-hide-navbar-logo-text-desktop',
      'catalog-strip-hide-navbar-logo-text-mobile'
    ];
    var catalogHomeLinkSelector = '[data-catalog-home-link]';

    function clearSettleTimer() {
      if (settleTimer) {
        window.clearTimeout(settleTimer);
        settleTimer = null;
      }
    }

    function withScrollCorrectionLock(callback) {
      scrollCorrectionLocked = true;
      callback();
      window.requestAnimationFrame(function () {
        scrollCorrectionLocked = false;
      });
    }

    function prepareClone(slide) {
      slide.dataset.catalogClone = 'true';
      slide.setAttribute('aria-hidden', 'true');

      Array.prototype.forEach.call(slide.querySelectorAll('[id]'), function (node) {
        node.removeAttribute('id');
      });

      Array.prototype.forEach.call(
        slide.querySelectorAll('a, button, input, select, textarea, summary, iframe'),
        function (node) {
          node.setAttribute('tabindex', '-1');
        }
      );
    }

    function buildLoopClones() {
      if (originalSlides.length < 2) return;

      var prependFragment = document.createDocumentFragment();
      var appendFragment = document.createDocumentFragment();

      originalSlides.forEach(function (slide) {
        var prependClone = slide.cloneNode(true);
        var appendClone = slide.cloneNode(true);

        prepareClone(prependClone);
        prepareClone(appendClone);

        prependFragment.appendChild(prependClone);
        appendFragment.appendChild(appendClone);
      });

      track.insertBefore(prependFragment, track.firstChild);
      track.appendChild(appendFragment);
    }

    function measureLoop() {
      if (originalSlides.length < 2) {
        loopingEnabled = false;
        return;
      }

      var appendSlides = Array.prototype.filter.call(track.children, function (child) {
        return child.dataset.catalogClone === 'true';
      }).slice(originalSlides.length);

      if (!appendSlides.length) {
        loopingEnabled = false;
        return;
      }

      loopStart = originalSlides[0].offsetLeft;
      loopSpan = appendSlides[0].offsetLeft - loopStart;
      loopingEnabled = loopSpan > 0;
    }

    function normalizeInfinitePosition(force) {
      if (!loopingEnabled || scrollCorrectionLocked) return;

      var current = track.scrollLeft;
      var next = current;
      var minLoopPosition = loopStart - loopThreshold;
      var maxLoopPosition = loopStart + loopSpan - loopThreshold;

      if (current < minLoopPosition) {
        next = current + loopSpan;
      } else if (current >= maxLoopPosition) {
        next = current - loopSpan;
      } else if (force) {
        if (current < loopStart) {
          next = current + loopSpan;
        } else if (current >= loopStart + loopSpan) {
          next = current - loopSpan;
        }
      }

      if (next !== current) {
        var shift = next - current;
        withScrollCorrectionLock(function () {
          track.scrollLeft = next;
        });
        if (dragging) {
          dragStartScrollLeft += shift;
        }
      }
    }

    function positionAtLoopStart() {
      measureLoop();
      if (!loopingEnabled) return;

      withScrollCorrectionLock(function () {
        track.scrollLeft = loopStart;
      });
    }

    function getSlideOffsets() {
      return Array.prototype.map.call(track.children, function (child) {
        return child.offsetLeft;
      });
    }

    function getNearestOffset(targetLeft, direction) {
      var offsets = getSlideOffsets();
      if (!offsets.length) return targetLeft;

      var nearest = offsets[0];
      if (direction > 0) {
        nearest = offsets[offsets.length - 1];
        for (var i = 0; i < offsets.length; i++) {
          if (offsets[i] >= targetLeft - 1) {
            nearest = offsets[i];
            break;
          }
        }
        return nearest;
      }

      for (var j = 0; j < offsets.length; j++) {
        if (offsets[j] <= targetLeft + 1) {
          nearest = offsets[j];
        } else {
          break;
        }
      }
      return nearest;
    }

    function getActiveSlide() {
      var slides = Array.prototype.filter.call(track.children, function (child) {
        return child.nodeType === 1;
      });
      if (!slides.length) return null;

      var center = track.scrollLeft + track.clientWidth / 2;
      var active = slides[0];
      var activeDistance = Infinity;

      slides.forEach(function (slide) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var distance = Math.abs(slideCenter - center);
        if (distance < activeDistance) {
          active = slide;
          activeDistance = distance;
        }
      });

      return active;
    }

    function updateCatalogNavbarState() {
      if (!document.body.classList.contains('template-page-catalog-strip')) return;

      var activeSlide = getActiveSlide();
      document.body.classList.toggle(
        'catalog-strip-text-slide-active',
        Boolean(activeSlide && activeSlide.classList.contains('a-garaia-catalog-horizontal__slide--text'))
      );
    }

    function syncCatalogNavbarOptions() {
      if (!document.body.classList.contains('template-page-catalog-strip')) return;

      document.body.classList.toggle(
        'catalog-strip-hide-navbar-cart-desktop',
        section.dataset.hideNavbarCartDesktop === 'true'
      );
      document.body.classList.toggle(
        'catalog-strip-hide-navbar-cart-mobile',
        section.dataset.hideNavbarCartMobile === 'true'
      );
      document.body.classList.toggle(
        'catalog-strip-hide-navbar-logo-text-desktop',
        section.dataset.hideNavbarLogoTextDesktop === 'true'
      );
      document.body.classList.toggle(
        'catalog-strip-hide-navbar-logo-text-mobile',
        section.dataset.hideNavbarLogoTextMobile === 'true'
      );
    }

    function getHomeHref() {
      var logoLink = document.querySelector('.custom-navbar__logo');
      return (logoLink && logoLink.getAttribute('href')) || '/';
    }

    function createCatalogHomeLink(className) {
      var link = document.createElement('a');
      link.href = getHomeHref();
      link.className = className;
      link.setAttribute('data-catalog-home-link', 'true');
      link.textContent = 'HOME';
      return link;
    }

    function syncCatalogHomeLink(container, shouldShow, className) {
      if (!container) return;

      var existing = container.querySelector(catalogHomeLinkSelector);
      if (!shouldShow) {
        if (existing) existing.remove();
        return;
      }

      if (!existing) {
        container.insertBefore(createCatalogHomeLink(className), container.firstChild);
      }
    }

    function syncCatalogHomeLinks() {
      if (!document.body.classList.contains('template-page-catalog-strip')) return;

      syncCatalogHomeLink(
        document.querySelector('.custom-navbar__links'),
        section.dataset.hideNavbarLogoTextDesktop === 'true',
        'custom-navbar__link custom-navbar__link--catalog-home'
      );
      syncCatalogHomeLink(
        document.querySelector('.custom-navbar__mobile-panel--root .custom-navbar__mobile-panel-body'),
        section.dataset.hideNavbarLogoTextMobile === 'true',
        'custom-navbar__mobile-nav-link custom-navbar__mobile-nav-link--catalog-home'
      );
    }

    function scheduleCatalogNavbarState() {
      if (navbarStateFrame) return;

      navbarStateFrame = window.requestAnimationFrame(function () {
        navbarStateFrame = null;
        updateCatalogNavbarState();
      });
    }

    function isInteractiveTarget(node) {
      return Boolean(
        node &&
          node.closest(
            'a, button, input, select, textarea, summary, label, .a-garaia-catalog-horizontal__inquire-text'
          )
      );
    }

    function scheduleSettleCheck() {
      clearSettleTimer();
      settleTimer = window.setTimeout(function () {
        pendingProgrammaticWrap = false;
        normalizeInfinitePosition(true);
      }, 140);
    }

    function scrollByPage(direction) {
      var desired = track.scrollLeft + direction * track.clientWidth;
      var target = getNearestOffset(desired, direction);

      if (loopingEnabled) {
        if (direction > 0 && target >= loopStart + loopSpan - loopThreshold) {
          pendingProgrammaticWrap = true;
        } else if (direction < 0 && target < loopStart - loopThreshold) {
          pendingProgrammaticWrap = true;
        } else {
          pendingProgrammaticWrap = false;
        }
      }

      clearSettleTimer();
      track.scrollTo({ left: target, behavior: 'smooth' });
      if (!pendingProgrammaticWrap) scheduleSettleCheck();
    }

    function onTrackScroll() {
      if (scrollCorrectionLocked) return;

      if (pendingProgrammaticWrap) {
        scheduleSettleCheck();
        scheduleCatalogNavbarState();
        return;
      }

      normalizeInfinitePosition(false);
      scheduleCatalogNavbarState();
    }

    function onWheel(event) {
      if (isInteractiveTarget(event.target)) return;

      pendingProgrammaticWrap = false;
      clearSettleTimer();

      if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
        event.preventDefault();
        track.scrollLeft += event.deltaY * wheelSpeed;
        return;
      }

      if (event.deltaX !== 0) {
        event.preventDefault();
        track.scrollLeft += event.deltaX * wheelSpeed;
      }
    }

    function onPointerDown(event) {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (isInteractiveTarget(event.target)) return;

      dragging = true;
      dragMoved = false;
      pendingProgrammaticWrap = false;
      clearSettleTimer();
      activePointerId = event.pointerId;
      dragStartX = event.clientX;
      dragStartScrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      track.setPointerCapture(activePointerId);
    }

    function onPointerMove(event) {
      if (!dragging || event.pointerId !== activePointerId) return;

      var deltaX = event.clientX - dragStartX;
      if (Math.abs(deltaX) > 3) dragMoved = true;
      track.scrollLeft = dragStartScrollLeft - deltaX;
    }

    function stopDragging(event) {
      if (!dragging) return;
      if (event && activePointerId !== null && event.pointerId !== activePointerId) return;

      dragging = false;
      track.classList.remove('is-dragging');
      if (activePointerId !== null && track.hasPointerCapture(activePointerId)) {
        track.releasePointerCapture(activePointerId);
      }
      activePointerId = null;
      scheduleSettleCheck();
    }

    function onTrackClick(event) {
      if (!dragMoved) return;
      event.preventDefault();
      event.stopPropagation();
      dragMoved = false;
    }

    function onSectionClick(event) {
      if (!clickNavigation) return;
      if (dragMoved) {
        dragMoved = false;
        return;
      }
      if (isInteractiveTarget(event.target)) return;

      var rect = section.getBoundingClientRect();
      var midpoint = rect.left + rect.width / 2;
      if (event.clientX >= midpoint) {
        scrollByPage(1);
      } else {
        scrollByPage(-1);
      }
    }

    function onDragStart(event) {
      event.preventDefault();
    }

    function onKeyDown(event) {
      if (!keyboardNav) return;
      if (!document.body.classList.contains('template-page-catalog-strip')) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      var active = document.activeElement;
      if (
        active &&
        (active.tagName === 'INPUT' ||
          active.tagName === 'TEXTAREA' ||
          active.tagName === 'SELECT' ||
          active.isContentEditable)
      ) {
        return;
      }

      event.preventDefault();
      scrollByPage(event.key === 'ArrowRight' ? 1 : -1);
    }

    function onResize() {
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }

      resizeFrame = window.requestAnimationFrame(function () {
        measureLoop();
        normalizeInfinitePosition(true);
        updateCatalogNavbarState();
      });
    }

    buildLoopClones();
    positionAtLoopStart();
    syncCatalogNavbarOptions();
    syncCatalogHomeLinks();
    updateCatalogNavbarState();

    track.addEventListener('scroll', onTrackScroll, { passive: true });
    section.addEventListener('wheel', onWheel, { passive: false });
    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', stopDragging);
    track.addEventListener('pointercancel', stopDragging);
    track.addEventListener('click', onTrackClick, true);
    section.addEventListener('click', onSectionClick);
    section.addEventListener('dragstart', onDragStart);
    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('resize', onResize);

    section.dataset.catalogInitialized = 'true';
    section._catalogCleanup = function () {
      var clones = track.querySelectorAll('[data-catalog-clone="true"]');

      track.removeEventListener('scroll', onTrackScroll, { passive: true });
      section.removeEventListener('wheel', onWheel);
      track.removeEventListener('pointerdown', onPointerDown);
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', stopDragging);
      track.removeEventListener('pointercancel', stopDragging);
      track.removeEventListener('click', onTrackClick, true);
      section.removeEventListener('click', onSectionClick);
      section.removeEventListener('dragstart', onDragStart);
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('resize', onResize);

      clearSettleTimer();
      if (resizeFrame) {
        window.cancelAnimationFrame(resizeFrame);
      }
      if (navbarStateFrame) {
        window.cancelAnimationFrame(navbarStateFrame);
      }
      document.body.classList.remove('catalog-strip-text-slide-active');
      navbarOptionClasses.forEach(function (className) {
        document.body.classList.remove(className);
      });
      document.querySelectorAll(catalogHomeLinkSelector).forEach(function (link) {
        link.remove();
      });

      clones.forEach(function (clone) {
        clone.remove();
      });

      section.dataset.catalogInitialized = 'false';
      delete section._catalogCleanup;
    };
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll('.a-garaia-catalog-horizontal[data-section-id]');
    sections.forEach(initCatalogSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector('.a-garaia-catalog-horizontal[data-section-id]');
    if (section && typeof section._catalogCleanup === 'function') {
      section._catalogCleanup();
    }
  });
})();
